import React from 'react'
import { useHistory } from 'react-router-dom'
import { CommonWrapper, Button } from 'src/components/misc'
export default () => {
  const history = useHistory()
  return (
    <CommonWrapper>
      <Button onClick={() => history.push(`/search/1`)}>
        视频图片列表搜索
      </Button>
      <Button onClick={() => history.push(`/search/0`)}>证书列表搜索</Button>
    </CommonWrapper>
  )
}
